import { Component, OnInit, ViewChild, forwardRef, Input } from '@angular/core';
import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { DemoozDateToStringPipe } from '@demooz/pipes';
import { DemoozProgressBarComponent } from '@demooz/components';
import { DataService } from '@app/services';

@Component({
    selector: 'app-ambassador-progression',
    templateUrl: './progression.component.html',
    styleUrls: ['./progression.component.scss'],
    imports: [
        IonIcon, TranslatePipe, DemoozDateToStringPipe, forwardRef(() => DemoozProgressBarComponent)
    ]
})
export class AmbassadorProgressionComponent  implements OnInit {
    
    @Input({alias : 'displayNbPoints', required : false}) displayNbPoints: boolean = true;
    @Input({alias : 'displayRanking', required : false}) displayRanking: boolean = true;
    @Input({alias : 'displayLevelProgression', required : false}) displayLevelProgression: boolean = true;
    
    ambassador = this.dataService.ambassador.value;   
    currentLevel: any|null = null;
    nextLevel: any|null = null;
    progressLevel: number = 0;
    dateUpdate: Date|null = null;
    
    constructor(      
        public translateService: TranslateService,
        public dataService: DataService
    ) { }

    ngOnInit() {
        let levels = this.dataService.operation.levels;
        let ambassadorLevel = this.ambassador?._pcd?.level || 0;
        this.currentLevel = this.dataService.operation.getLevel(ambassadorLevel);   
        if(typeof levels[ambassadorLevel+1] !== 'undefined'){
            this.nextLevel = levels[ambassadorLevel+1];
        }        
        
        let previousLevel: any|undefined = undefined;
        if(typeof levels[ambassadorLevel-1] !== 'undefined'){
            previousLevel = levels[ambassadorLevel-1];
        }
        
        let maxPointsPreviousLevel = (previousLevel ? previousLevel.maxPoints : 0);        
        let nbPoints = (this.ambassador?._pcd?.points - maxPointsPreviousLevel) || 0;        
        this.progressLevel = (this.currentLevel?.maxPoints > 0 ? nbPoints / (this.currentLevel.maxPoints - maxPointsPreviousLevel) : 0) * 100;
        
        this.dateUpdate = (this.ambassador?._pcd?.updated ? new Date(this.ambassador._pcd.updated) : null);
    }
}
